import "../resource_collection/behavior.js";

// Each behavior must be registered with the name of the component template
class AwardsBehavior extends Sparkle.PageBuilder.Components.ResourceCollectionAbstractBehavior {}
AwardsBehavior.register("awards");
